import React, { useEffect, useState } from 'react'
import { Grid, Row, Col, Button, Input, SelectPicker, Form } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
// //import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import ExpertListTable from '../../../components/table/expertListTable/ExpertListTable'
import { searchExpert } from '../../../redux/actions/assignExpert'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'

export default function SeachExpert({
  schema,
  selectedExpert,
  onClickSelect,
  onClickOnline,
  isSubProject,
}) {
  const { register, handleSubmit, errors, control, reset } = useForm()

  //const [expertData, setExpertData] = useState(schema.itemsList || [])
  const [expertData, setExpertData] = useState([])
  const [totalSize, setTotalSize] = useState(schema.totalSize || schema?.itemsList?.length || 0)
  const [currentSeach, setCurrentSeach] = useState()

  useEffect(() => {
    handleSearchExpert({name: '', expert: '', accountType: '', year: '' }, 1, 5)
  }, [])

  const handleSearchExpert = async (data, pagenum, pagesize) => {
    let search = {
      name: data?.name,
      expert: data?.expert,
      accountType: data?.accountType,
      year: data?.year && !isNaN(data?.year) ? parseInt(data?.year, 10) : null,
    }

    const searchResult = await searchExpert(search, pagenum, pagesize)

    setTotalSize(searchResult?.model?.totalSize)
    setExpertData(searchResult?.model?.itemsList)
  }

  const handleChangePage = (pagesize, pagenum) => {
    handleSearchExpert(currentSeach, pagenum, pagesize)
  }

  const onSubmit = (data) => {
    setCurrentSeach(data)
    handleSearchExpert(data, 1, 5)
  }

  const onClickClearValue = () => {
    setExpertData()
    reset({ name: '', expert: '', accountType: '', year: '' })
  }

  return (
    <>
      <Grid fluid>
        <Form>
          <Row>
            <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={12} lg={8}>
              <Input
                style={{ width: '100%' }}
                placeholder="กรอกชื่อผู้ทรงคุณวุฒิ"
                name={'name'}
                inputRef={register}
              />
            </Col>

            <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={12} lg={8}>
              <ErrorMessage error={errors.year} />
              <Controller
                name={'year'}
                control={control}
                defaultValue={''}
                render={(props) => {
                  return (
                    <Input
                      style={{ width: '100%' }}
                      placeholder={'กรอกปีงบประมาณ'}
                      value={props.value}
                      maxLength={4}
                      onChange={(value, e) => {
                        if (isNaN(value)) {
                          return
                        }
                        props.onChange(value)
                      }}
                    />
                  )
                }}
              />
            </Col>

            {schema?.accountTypeData && (
              <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={12} lg={8}>
                <ErrorMessage error={errors.accountType} />
                <Controller
                  name={'accountType'}
                  control={control}
                  defaultValue={''}
                  render={(props) => {
                    return (
                      <SelectPicker
                        size="lg"
                        data={schema.accountTypeData}
                        value={props.value}
                        style={{ width: '100%' }}
                        placeholder="เลือกประเภทบัญชี"
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            )}

            {schema?.expertiseData && (
              <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={12} lg={8}>
                <ErrorMessage error={errors.expertise} />
                <Controller
                  name={'expert'}
                  control={control}
                  defaultValue={''}
                  render={(props) => {
                    return (
                      <SelectPicker
                        size="lg"
                        data={schema.expertiseData}
                        value={props.value}
                        style={{ width: '100%' }}
                        placeholder="เลือกความเชี่ยวชาญ"
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            )}
          </Row>
          <Row>
            <Col style={{ marginBottom: 10 }} xs={24} sm={24} md={6} lg={4}>
              <SaveButton icon="search" block onClick={handleSubmit(onSubmit)}>
                {`ค้นหา`}
              </SaveButton>
              {/* <Button appearance="ghost" block onClick={handleSubmit(onSubmit)}>
                ค้นหา
              </Button> */}
            </Col>
            <Col style={{ marginBottom: 10 }} xs={24} sm={24} md={6} lg={4}>
              <CancelButton block onClick={onClickClearValue}>
                {'ล้างข้อมูล'}
              </CancelButton>
              {/* <Button appearance="ghost" block onClick={onClickClearValue}>
                ล้างข้อมูล
              </Button> */}
            </Col>
          </Row>
        </Form>
      </Grid>
      <ExpertListTable
        data={expertData}
        selectedExpert={selectedExpert}
        isEditable
        isSubProject={isSubProject}
        onClickSelect={onClickSelect}
        onClickOnline={onClickOnline}
        onReload={handleChangePage}
        totalSize={totalSize}
      />
    </>
  )
}
